module.exports = __webpack_public_path__ + "static/button-zoom-f1e099da74f100771bed0e983b374206.png";